import React, { useState, useEffect, useContext, useRef } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import Swal from 'sweetalert2';

import logo from './logo.svg';
import './App.css';

import Table from './components/Table';

import ThemeSwitcher from './components/ThemeChange';

function App() {

  const config = {
    uri: 'https://elbatallon.devbybit.com',
  };
  const apiURL = 'https://elbatallon.devbybit.com/api.php';

  const [stats, setStats] = useState(null);

  useEffect(() => {
    const fetchStats = () => {
      fetch("./api.php")
        .then((res) => res.json())
        .then((data) => setStats(data))
        .catch((error) => console.error("Error obteniendo datos:", error));
    };

    fetchStats(); // Llamar una vez al cargar
    const interval = setInterval(fetchStats, 100); // Actualizar cada 1 segundo

    return () => clearInterval(interval); // Limpiar el intervalo al desmontar
  }, []);


  if (!stats) return <p>Cargando datos...</p>;

  return (
    <>
<div className="page page-center">
  <div className="container container-tight py-4">
    <div className="text-center mb-4">
      <a href="https://devbybit.com" className="navbar-brand">
        <img src="https://license.devbybit.com/parent/img/icon.png" className="mr-3 h-8" alt="DevByBit Logo" />
        <span className="self-center text-2 font-semibold whitespace-nowrap dark:text-white " style={{ fontSize: '48px'}}>DevByBit</span>
      </a>
    </div>
    <div className="card card-md">
      <div className="card-body">
        <h2 className="mb-3">{stats.node.name}</h2>
        <p className="text-secondary mb-4">{stats.node.message}</p>
        <ul className="list-unstyled space-y">
          
          <li className="row g-2">
            <span className="col-auto">
              {stats.cpu.usage_percent <= 49 ? (
                <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="icon me-1 text-success icon-2"><path d="M5 12l5 5l10 -10" /></svg>
              ) : stats.cpu.usage_percent >= 50 ? (
                <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon me-1 text-warning icon-2"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M12 9v4" /><path d="M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0z" /><path d="M12 16h.01" /></svg>
              ) : (
                <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="currentColor"  class="icon me-1 text-danger icon-2"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M21 11a1 1 0 0 1 1 1a10 10 0 0 1 -5 8.656a1 1 0 0 1 -1.302 -.268l-.064 -.098l-3 -5.19a.995 .995 0 0 1 -.133 -.542l.01 -.11l.023 -.106l.034 -.106l.046 -.1l.056 -.094l.067 -.089a.994 .994 0 0 1 .165 -.155l.098 -.064a2 2 0 0 0 .993 -1.57l.007 -.163a1 1 0 0 1 .883 -.994l.117 -.007h6z" /><path d="M7 3.344a10 10 0 0 1 10 0a1 1 0 0 1 .418 1.262l-.052 .104l-3 5.19l-.064 .098a.994 .994 0 0 1 -.155 .165l-.089 .067a1 1 0 0 1 -.195 .102l-.105 .034l-.107 .022a1.003 1.003 0 0 1 -.547 -.07l-.104 -.052a2 2 0 0 0 -1.842 -.082l-.158 .082a1 1 0 0 1 -1.302 -.268l-.064 -.098l-3 -5.19a1 1 0 0 1 .366 -1.366z" /><path d="M9 11a1 1 0 0 1 .993 .884l.007 .117a2 2 0 0 0 .861 1.645l.237 .152a.994 .994 0 0 1 .165 .155l.067 .089l.056 .095l.045 .099c.014 .036 .026 .07 .035 .106l.022 .107l.011 .11a.994 .994 0 0 1 -.08 .437l-.053 .104l-3 5.19a1 1 0 0 1 -1.366 .366a10 10 0 0 1 -5 -8.656a1 1 0 0 1 .883 -.993l.117 -.007h6z" /></svg>
              )}
            </span>
            <span className="col">
              <strong className="d-block">
                CPU Usage: {stats.cpu.usage_percent}% / {stats.cpu.max_percent}%
              </strong>
              <span className="d-block text-secondary">
                <div className="progress progress-1 mb-2">
                  <div className="progress-bar" style={{ width: `${stats.cpu.load}%` }} role="progressbar" aria-valuenow={stats.cpu.load} aria-valuemin={0} aria-valuemax={100} >
                  {stats.cpu.usage_percent}%
                  </div>
                </div>
              </span>
            </span>
          </li>

          <li className="row g-2">
            <span className="col-auto">
              {stats.memory.usage_percent <= 49 ? (
                <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="icon me-1 text-success icon-2"><path d="M5 12l5 5l10 -10" /></svg>
              ) : stats.memory.usage_percent >= 50 ? (
                <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon me-1 text-warning icon-2"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M12 9v4" /><path d="M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0z" /><path d="M12 16h.01" /></svg>
              ) : (
                <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="currentColor"  class="icon me-1 text-danger icon-2"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M21 11a1 1 0 0 1 1 1a10 10 0 0 1 -5 8.656a1 1 0 0 1 -1.302 -.268l-.064 -.098l-3 -5.19a.995 .995 0 0 1 -.133 -.542l.01 -.11l.023 -.106l.034 -.106l.046 -.1l.056 -.094l.067 -.089a.994 .994 0 0 1 .165 -.155l.098 -.064a2 2 0 0 0 .993 -1.57l.007 -.163a1 1 0 0 1 .883 -.994l.117 -.007h6z" /><path d="M7 3.344a10 10 0 0 1 10 0a1 1 0 0 1 .418 1.262l-.052 .104l-3 5.19l-.064 .098a.994 .994 0 0 1 -.155 .165l-.089 .067a1 1 0 0 1 -.195 .102l-.105 .034l-.107 .022a1.003 1.003 0 0 1 -.547 -.07l-.104 -.052a2 2 0 0 0 -1.842 -.082l-.158 .082a1 1 0 0 1 -1.302 -.268l-.064 -.098l-3 -5.19a1 1 0 0 1 .366 -1.366z" /><path d="M9 11a1 1 0 0 1 .993 .884l.007 .117a2 2 0 0 0 .861 1.645l.237 .152a.994 .994 0 0 1 .165 .155l.067 .089l.056 .095l.045 .099c.014 .036 .026 .07 .035 .106l.022 .107l.011 .11a.994 .994 0 0 1 -.08 .437l-.053 .104l-3 5.19a1 1 0 0 1 -1.366 .366a10 10 0 0 1 -5 -8.656a1 1 0 0 1 .883 -.993l.117 -.007h6z" /></svg>
              )}
            </span>
            <span className="col">
              <strong className="d-block">
                Memory Usage: {stats.memory.used_mb} MB / {stats.memory.total_mb} MB
              </strong>
              <span className="d-block text-secondary">
                <div className="progress progress-1 mb-2">
                  <div className="progress-bar" style={{ width: `${stats.memory.usage_percent}%` }} role="progressbar" aria-valuenow={stats.memory.usage_percent} aria-valuemin={0} aria-valuemax={100} >
                  {stats.memory.usage_percent}%
                  </div>
                </div>
              </span>
            </span>
          </li>
          <li className="row g-2">
            <span className="col-auto">
              {stats.disk.usage_percent <= 49 ? (
                <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="icon me-1 text-success icon-2"><path d="M5 12l5 5l10 -10" /></svg>
              ) : stats.disk.usage_percent >= 50 ? (
                <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon me-1 text-warning icon-2"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M12 9v4" /><path d="M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0z" /><path d="M12 16h.01" /></svg>
              ) : (
                <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="currentColor"  class="icon me-1 text-danger icon-2"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M21 11a1 1 0 0 1 1 1a10 10 0 0 1 -5 8.656a1 1 0 0 1 -1.302 -.268l-.064 -.098l-3 -5.19a.995 .995 0 0 1 -.133 -.542l.01 -.11l.023 -.106l.034 -.106l.046 -.1l.056 -.094l.067 -.089a.994 .994 0 0 1 .165 -.155l.098 -.064a2 2 0 0 0 .993 -1.57l.007 -.163a1 1 0 0 1 .883 -.994l.117 -.007h6z" /><path d="M7 3.344a10 10 0 0 1 10 0a1 1 0 0 1 .418 1.262l-.052 .104l-3 5.19l-.064 .098a.994 .994 0 0 1 -.155 .165l-.089 .067a1 1 0 0 1 -.195 .102l-.105 .034l-.107 .022a1.003 1.003 0 0 1 -.547 -.07l-.104 -.052a2 2 0 0 0 -1.842 -.082l-.158 .082a1 1 0 0 1 -1.302 -.268l-.064 -.098l-3 -5.19a1 1 0 0 1 .366 -1.366z" /><path d="M9 11a1 1 0 0 1 .993 .884l.007 .117a2 2 0 0 0 .861 1.645l.237 .152a.994 .994 0 0 1 .165 .155l.067 .089l.056 .095l.045 .099c.014 .036 .026 .07 .035 .106l.022 .107l.011 .11a.994 .994 0 0 1 -.08 .437l-.053 .104l-3 5.19a1 1 0 0 1 -1.366 .366a10 10 0 0 1 -5 -8.656a1 1 0 0 1 .883 -.993l.117 -.007h6z" /></svg>
              )}
            </span>
            <span className="col">
              <strong className="d-block">
                Disk Usage: {stats.disk.used_mb} MB / {stats.disk.total_mb} MB
              </strong>
              <span className="d-block text-secondary">
                <div className="progress progress-1 mb-2">
                  <div className="progress-bar" style={{ width: `${stats.disk.usage_percent}%` }} role="progressbar" aria-valuenow={stats.disk.usage_percent} aria-valuemin={0} aria-valuemax={100} >
                  {stats.disk.usage_percent}%
                  </div>
                </div>
              </span>
            </span>
          </li>

        </ul>
        <div className="my-4">
          <a href="https://builtbybit.com/resources/primeoverview-vps-analytics.61428" className="btn btn-primary w-100"> Purchase Software </a>
        </div>
        <p className="text-secondary">This software has a completely free trial, <a href="https://builtbybit.com/resources/vps-overview-free.61427">purchase your version free here</a>.</p>
        <label class="form-label">
        <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon me-1 text-success"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M6.657 16c-2.572 0 -4.657 -2.007 -4.657 -4.483c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99c1.913 0 3.464 1.56 3.464 3.486c0 1.927 -1.551 3.487 -3.465 3.487h-11.878" /><path d="M12 16v5" /><path d="M16 16v4a1 1 0 0 0 1 1h4" /><path d="M8 16v4a1 1 0 0 1 -1 1h-4" /></svg>
          Uptime: {stats.uptime.formatted}
        </label>
      </div>
    </div>

    <ThemeSwitcher />

  </div>
</div>

    </>
  );
}

export default App;
